export default __webpack_public_path__ + "static/media/medium.c2f12865.svg";